import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import WebComponent from '../../WebComponent.js'
import I18n from '../../i18n.js'
import StammdatenService from '../../services/StammdatenService.js'
import AdminService from '../../services/AdminService.js'

export default class GebuchteKapazitaet extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'gebuchte-kapazitaet-reload-triggered'
    }
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }

      .flexRowView {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
      }

      .gebucht-container {
        overflow-x: scroll;
        margin-left: 120px;
      }

      .gebucht-header {
        font-weight: bold;
        text-align: center;
      }

      .gebucht-row {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 6px; /* inputs have a top margin of 4px -> 10px total */
      }

      .gebucht-row > * {
        flex: 1 0 80px;
      }

      .monat {
        width: 110px;
        text-align: right;
        position: absolute;
        transform: translateX(-120px);
      }
    `
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  constructor() {
    super()
    this.adminService = new AdminService()
    this.stammdatenService = new StammdatenService()
    this.data = {}
    this.jahr = 0
    this.maxJahr = 0
    this.nextUrl = ''
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      send(GebuchteKapazitaet.EVENT_KEYS.RELOAD_TRIGGERED)
      this._loadData()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)

    this.calculateYear();
    this._loadData()
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
  }

  _loadData() {
    this.adminService.list('kapazitaet/gebucht/' + this.jahr)
      .then(kapazitaeten => {
        this.data = kapazitaeten
        this.render()
      })
      .catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('admin.gebuchte.kapazitaet.title')}">
        <nav class="kapazitaet-title-navigation">
          <div class="flexRowView">
            <isceco-button
              id="kapazitaet-jahr-zurueck"
              variant="primary"
              size="small"
              icon="step backward"
              title="${this.i18n.translate('admin.gebuchte.kapazitaet.button.year.backward.title')}"
              ?disabled="${this.isBackwardButtonDisabled()}"
              @click="${_ => {
                this.changeYear(-1)
              }}"
            ></isceco-button>
            <isceco-button
              id="kapazitaet-jahr-vorwaerts"
              variant="primary"
              size="small"
              icon="step forward"
              title="${this.i18n.translate('admin.gebuchte.kapazitaet.button.year.forward.title')}"
              ?disabled="${this.isForwardButtonDisabled()}"
              @click="${_ => {
                this.changeYear(1)
              }}"
            ></isceco-button>
            <isceco-button
              id="kapazitaet-speichern"
              variant="primary"
              size="small"
              icon="save"
              title="${this.i18n.translate('admin.gebuchte.kapazitaet.button.speichern.title')}"
              @click="${_ => {
                if (document.getElementById("kapazitaet-form").validate()) {
                  document.getElementById('kapazitaet-confirm-dialog').removeAttribute('hidden')
                }
              }}"
            ></isceco-button>
          </div>
        </nav>
      </isceco-title>

      <p>${this.i18n.translate('admin.gebuchte.kapazitaet.aktualisiert')} ${this.getModTime()}</p>
      <isceco-form id="kapazitaet-form"
                   prevent-navigation
                   @abort="${event => this.handleAbort(event)}"
      >
        <div slot="form-elements" class="gebucht-container">
          <div class="gebucht-row">
            <div class="gebucht-header monat"></div>
            <div class="gebucht-header">Wallbach<br/>EGO</div>
            <div class="gebucht-header">Oltingue<br/>EGO</div>
            <div class="gebucht-header">Griespass<br/>EGO</div>
            <div class="gebucht-header">Wallbach<br/>EGZ</div>
            <div class="gebucht-header">Oltingue<br/>EGZ</div>
            <div class="gebucht-header">Griespass<br/>EGZ</div>
            <div class="gebucht-header">Wallbach<br/>Gaznat</div>
            <div class="gebucht-header">Oltingue<br/>Gaznat</div>
            <div class="gebucht-header">Griespass<br/>Gaznat</div>
            <div class="gebucht-header">Wallbach<br/>GVM</div>
            <div class="gebucht-header">Oltingue<br/>GVM</div>
            <div class="gebucht-header">Griespass<br/>GVM</div>
            <div class="gebucht-header">Basel</div>
            <div class="gebucht-header">Bizzarone</div>
            <div class="gebucht-header">La Cure</div>
            <div class="gebucht-header">Fallentor</div>
            <div class="gebucht-header">Höchst</div>
            <div class="gebucht-header">Savoie</div>
            <div class="gebucht-header">Schönen-<br/>buch</div>
          </div>
          <!-- Rows -->
          ${this.data.map((row, index) => html`
            <div class="gebucht-row">
              <div id="monat-${index}" class="monat">${row.monat}</div>
              ${this.getGridRow(row, index)}
            </div>
          `)}
        </div>
      </isceco-form>

      <isceco-dialog
        hidden
        header="${this.i18n.translate('admin.gebuchte.kapazitaet.confirm.header')}"
        id="kapazitaet-confirm-dialog"
        confirm-button="${this.i18n.translate('admin.gebuchte.kapazitaet.confirm.confirm')}"
        Cancel-button="${this.i18n.translate('admin.gebuchte.kapazitaet.confirm.cancel')}"
        @submit="${confirmed => this._close(confirmed)}">
      </isceco-dialog>
      <isceco-dialog id="abort-dialog"
                     hidden
                     header="${this.i18n.translate('admin.confirm.changes.dialog.titel')}"
                     description="${this.i18n.translate('admin.confirm.changes.dialog.beschreibung')}"
                     confirm-button="${this.i18n.translate('admin.confirm.changes.dialog.bestaetigen')}"
                     cancel-button="${this.i18n.translate('admin.confirm.changes.dialog.abbrechen')}"
                     @submit="${event => this.confirmAbort(event)}"
      ></isceco-dialog>
    `
  }

  calculateYear() {
    const date = new Date()
    // Monatswerte 0-11
    const year = date.getMonth() < 8 ? date.getFullYear() - 1 : date.getFullYear()
    this.jahr = year;
    this.maxJahr = year + 1;
  }

  getModTime() {
    const modDates = this.data.map(obj => new Date(obj.modificationDate))
    return html`${formatDateTime(Math.max.apply(null, modDates))}`
  }

  isBackwardButtonDisabled() {
    return this.jahr === 2024;
  }

  isForwardButtonDisabled() {
    return this.jahr === this.maxJahr;
  }

  getGridRow(month, index) {
    return html`
      <isceco-number-input name="wall-ego-value-${index}" maximum-fraction-digits="0" min="0" value="${month.wbEgo}"
                           @change="${e => this.updateValue(index, 'wbEgo', e)}"></isceco-number-input>
      <isceco-number-input name="olt-ego-value-${index}" maximum-fraction-digits="0" min="0" value="${month.oltEgo}"
                           @change="${e => this.updateValue(index, 'oltEgo', e)}"></isceco-number-input>
      <isceco-number-input name="grie-ego-value-${index}" maximum-fraction-digits="0" min="0" value="${month.grieEgo}"
                           @change="${e => this.updateValue(index, 'grieEgo', e)}"></isceco-number-input>
      <isceco-number-input name="wall-egz-value-${index}" maximum-fraction-digits="0" min="0" value="${month.wbEgz}"
                           @change="${e => this.updateValue(index, 'wbEgz', e)}"></isceco-number-input>
      <isceco-number-input name="olt-egz-value-${index}" maximum-fraction-digits="0" min="0" value="${month.oltEgz}"
                           @change="${e => this.updateValue(index, 'oltEgz', e)}"></isceco-number-input>
      <isceco-number-input name="grie-egz-value-${index}" maximum-fraction-digits="0" min="0" value="${month.grieEgz}"
                           @change="${e => this.updateValue(index, 'grieEgz', e)}"></isceco-number-input>
      <isceco-number-input name="wall-gaznat-value-${index}" maximum-fraction-digits="0" min="0" value="${month.wbGaznat}"
                           @change="${e => this.updateValue(index, 'wbGaznat', e)}"></isceco-number-input>
      <isceco-number-input name="olt-gaznat-value-${index}" maximum-fraction-digits="0" min="0" value="${month.oltGaznat}"
                           @change="${e => this.updateValue(index, 'oltGaznat', e)}"></isceco-number-input>
      <isceco-number-input name="grie-gaznat-value-${index}" maximum-fraction-digits="0" min="0" value="${month.grieGaznat}"
                           @change="${e => this.updateValue(index, 'grieGaznat', e)}"></isceco-number-input>
      <isceco-number-input name="wall-gvm-value-${index}" maximum-fraction-digits="0" min="0" value="${month.wbGvm}"
                           @change="${e => this.updateValue(index, 'wbGvm', e)}"></isceco-number-input>
      <isceco-number-input name="olt-gvm-value-${index}" maximum-fraction-digits="0" min="0" value="${month.oltGvm}"
                           @change="${e => this.updateValue(index, 'oltGvm', e)}"></isceco-number-input>
      <isceco-number-input name="grie-gvm-value-${index}" maximum-fraction-digits="0" min="0" value="${month.grieGvm}"
                           @change="${e => this.updateValue(index, 'grieGvm', e)}"></isceco-number-input>
      <isceco-number-input name="rcb-value-${index}" maximum-fraction-digits="0" min="0" value="${month.rcb}"
                           @change="${e => this.updateValue(index, 'rcb', e)}"></isceco-number-input>
      <isceco-number-input name="gebi-value-${index}" maximum-fraction-digits="0" min="0" value="${month.gebi}"
                           @change="${e => this.updateValue(index, 'gebi', e)}"></isceco-number-input>
      <isceco-number-input name="lac-value-${index}" maximum-fraction-digits="0" min="0" value="${month.lac}"
                           @change="${e => this.updateValue(index, 'lac', e)}"></isceco-number-input>
      <isceco-number-input name="rcf-value-${index}" maximum-fraction-digits="0" min="0" value="${month.rcf}"
                           @change="${e => this.updateValue(index, 'rcf', e)}"></isceco-number-input>
      <isceco-number-input name="hoe-value-${index}" maximum-fraction-digits="0" min="0" value="${month.hoe}"
                           @change="${e => this.updateValue(index, 'hoe', e)}"></isceco-number-input>
      <isceco-number-input name="sav-value-${index}" maximum-fraction-digits="0" min="0" value="${month.sav}"
                           @change="${e => this.updateValue(index, 'sav', e)}"></isceco-number-input>
      <isceco-number-input name="schoe-value-${index}" maximum-fraction-digits="0" min="0" value="${month.schoe}"
                           @change="${e => this.updateValue(index, 'schoe', e)}"></isceco-number-input>
    `
  }

  changeYear(change) {
    this.jahr = this.jahr + change
    this._loadData();
  }

  updateValue(index, key, event) {
    this.data[index][key] = event.detail.value
  }

  _close(e) {
    e.target.hidden = true
    if (e.detail.confirmed) {
      this._save()
    }
  }

  _save() {
    this.adminService.updateList(this.data, 'kapazitaet/gebucht')
      .then(() => {
        // Reset the valueChanged from the form inputs, data are already saved in another way
        const formElements = document.querySelector('#kapazitaet-form').getFormElements();
        if (formElements) {
          formElements.forEach(element => {element.valueChanged = false})
        }
        showAlert(this.i18n.translate('admin.gebuchte.kapazitaet.createupdate.success'), '', 'success')
        this._refresh()
      })
      .catch(() => {
        showAlert(this.i18n.translate('admin.gebuchte.kapazitaet.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  handleAbort = event => {
    const dialog = document.querySelector('#abort-dialog')
    dialog.hidden = false
    this.nextUrl = event.detail.url ?? '#Cockpit'
  }

  confirmAbort = event => {
    if (event.detail.confirmed) {
      navigate({to: this.nextUrl, allow: true})
    } else {
      event.target.hidden = true
    }
  }
}
customElements.define('gasmonitoring-frontend-admin-gebuchte-kapazitaet', GebuchteKapazitaet)
